import React from 'react';
import { BookOpenIcon, CheckIcon, GiftIcon, GlobeIcon, LockIcon } from 'lucide-react';
import { SectionHeader } from '../SectionHeader';
import { CtaButton } from '../CtaButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
import { volumes } from '../../data/volumes';
import { bonuses } from '../../data/bonuses';
import { images, offerIncludes } from '../../data/offer';
export function OfferSection() {
  return <section id="offer" className="w-full bg-navy-950 px-5 py-16 sm:py-24" data-id="element-242" data-mp="6j189dsm7r35">
      <SectionHeader tone="dark" eyebrow="Exclusive launch offer" title="Everything You Need to Organize Your Low Back Pain Assessments" lead="Here’s everything included with your purchase." data-id="element-243" data-mp="1p6q4esnrk66" />

      <div className="mx-auto mt-10 max-w-3xl overflow-hidden rounded-[2rem] bg-white shadow-[0_30px_80px_-20px_rgba(34,199,240,0.35)] ring-4 ring-brand" data-id="element-244" data-mp="3iylkmarby8vl">
        <div className="bg-navy-900 px-5 pb-2 pt-6" data-id="element-245" data-mp="3exjkzsti3ut3">
          <img src={images.mockup} alt="Complete Low Back Pain Assessment Blueprint collection" className="mx-auto w-full max-w-md" data-id="element-246" data-mp="1asadrslifu6p" />
        </div>

        <div className="p-6 sm:p-10" data-id="element-247" data-mp="1fkbkkyzwsspc">
          <div className="grid gap-8 md:grid-cols-2" data-id="element-248" data-mp="10tuo7u24sszb">
            <div data-id="element-249" data-mp="10vfhlgcpm5vl">
              <p className="flex items-center gap-2 font-display text-xl font-extrabold uppercase text-ink" data-id="element-250" data-mp="10rrmicrm9ber">
                <BookOpenIcon className="h-5 w-5 text-brand-dark" aria-hidden="true" data-id="element-251" data-mp="15ql0e6atf4fg" /> The Complete 6-Volume Collection
              </p>
              <ul className="mt-3 space-y-2" data-id="element-252" data-mp="1yhuyoh1851im">
                {volumes.map(v => <li key={v.numeral} className="flex items-start gap-2.5 text-base leading-snug text-slate-800" data-id="element-253" data-mp="1ki3mmlu9pv79">
                    <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-emerald-600" strokeWidth={3} aria-hidden="true" data-id="element-254" data-mp="1oinkjrmo12ug" />
                    {v.title}.
                  </li>)}
              </ul>
            </div>
            <div data-id="element-255" data-mp="d5tjyxbzjypp">
              <p className="flex items-center gap-2 font-display text-xl font-extrabold uppercase text-ink" data-id="element-256" data-mp="d25nbpb8uw6r">
                <GiftIcon className="h-5 w-5 text-flame" aria-hidden="true" data-id="element-257" data-mp="2fsrutxvcdt2t" /> Plus 5 Specialized Bonuses
              </p>
              <ul className="mt-3 space-y-2" data-id="element-258" data-mp="260uholkrwr1g">
                {bonuses.map(b => <li key={b.number} className="flex items-start gap-2.5 text-base leading-snug text-slate-800" data-id="element-259" data-mp="21210ai2d8fw0">
                    <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-emerald-600" strokeWidth={3} aria-hidden="true" data-id="element-260" data-mp="1x05zdeock4ir" />
                    {b.title}.
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="mt-8 rounded-2xl bg-paper p-5 text-center" data-id="element-261" data-mp="1n2rwyiz9dg9g">
            <p className="font-display text-lg font-bold uppercase text-ink" data-id="element-262" data-mp="1i3yk8srsptac">Your Complete Collection</p>
            <p className="mt-1 text-base text-slate-700" data-id="element-263" data-mp="3hf80hc0o6gam">
              Six educational volumes, five practical resources, and a structured collection focused on the assessment of low back pain.
            </p>
          </div>

          <div className="mt-10 text-center" data-id="element-264" data-mp="3kxoxw48x5vzp">
            <p className="font-display text-lg font-bold uppercase tracking-wide text-slate-600" data-id="element-265" data-mp="3ozk1jfebolgn">Get the complete collection today for just…</p>
            <p className="mt-1 font-display text-[7rem] font-black leading-none text-flame sm:text-[9rem]" data-id="element-266" data-mp="3tr22i3gcim1m">$27</p>
            <p className="font-display text-xl font-extrabold uppercase tracking-[0.15em] text-ink" data-id="element-267" data-mp="2jfphk7ql783">One-time payment</p>
          </div>

          <ul className="mx-auto mt-6 grid max-w-md gap-2" data-id="element-268" data-mp="360o5dyiwlx06">
            {offerIncludes.map(item => <li key={item} className="flex items-center gap-2.5 text-base font-medium text-slate-800" data-id="element-269" data-mp="3azhme0xeg653">
                <CheckIcon className="h-5 w-5 shrink-0 text-emerald-600" strokeWidth={3} aria-hidden="true" data-id="element-270" data-mp="3fzn8z2otb2gb" />
                {item}
              </li>)}
          </ul>

          <div className="mx-auto mt-6 flex max-w-md items-start gap-3 rounded-xl bg-brand-soft p-4" data-id="element-271" data-mp="v8wj2l73eu5w">
            <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand-dark" aria-hidden="true" data-id="element-272" data-mp="245jsa46vfunz" />
            <p className="text-sm leading-relaxed text-navy-900" data-id="element-273" data-mp="1z70560gjkcu1">
              <strong data-id="element-274" data-mp="1z8l38022edwn">Automatic currency conversion.</strong> Price in USD. Currency is converted automatically to your local currency at
              checkout, where supported.
            </p>
          </div>

          <p className="mx-auto mt-6 max-w-xl text-center text-base leading-relaxed text-slate-700" data-id="element-275" data-mp="289j3c79du19y">
            Instead of searching through disconnected notes and resources, you’ll have a dedicated collection designed around the low back pain
            assessment process.
          </p>

          <CtaButton label="Yes! I Want Low Back Pain Assessment Blueprint™" data-id="element-276" data-mp="2vz3q718npioi" />

          <div className="mx-auto max-w-xl" data-id="element-277" data-mp="2rvxo85skudnu">
            <div className="mt-8 rounded-2xl bg-navy-900 px-4 pb-5 pt-1" data-id="element-278" data-mp="35v6twbj5ppdk">
              <Countdown data-id="element-279" data-mp="35t2qrvt30uec" />
            </div>
            <ScarcityBar data-id="element-280" data-mp="30wvhbt1h90rn" />
            <p className="mt-5 text-center text-sm leading-relaxed text-slate-600" data-id="element-281" data-mp="30xf3jly5ubbh">
              When the promotional period ends, the price may return to its regular value.
            </p>
            <p className="mt-3 flex items-center justify-center gap-2 text-center text-sm font-semibold text-slate-700" data-id="element-282" data-mp="3pfnrxq8k6mx4">
              <LockIcon className="h-4 w-4 text-emerald-600" aria-hidden="true" data-id="element-283" data-mp="3ajg9aucsttjy" />
              Secure checkout · One-time payment · Digital educational resources
            </p>
          </div>
        </div>
      </div>
    </section>;
}